@if(showSpinner){
    <div class="h-100 flex flex-center">
        <sa-spinner class="" size="64"></sa-spinner>
    </div>
}@else{
    <div class="sa-mfa-verification-container flex">
        <div class="sa-mfa-verification-wrapper">
            <sa-page-layout [showRightContent]="false">
                <div class="sa-mfa-verification-top-content" top-content>
                    <sa-icon size='100' icon='sarasFullLogo' altText='S'></sa-icon>
                </div>
                <div left-content>
                    <div class="sa-mfa-verification flex flex-center flex-col">
                        <div>
                            <img src="../assets/mfa-verfication-logo.jpg" alt="" height="219px" width="320px">
                        </div>
                        <div class="sa-mfa-content flex flex-col flex-center">
                            <p class="title">MFA Authentication</p>
                            <p class="sub-title" style="margin: 0;">Enter the 6-digit code from your authentication app to complete verification</p>
                        </div>
                        <div class="sa-mfa-qrcode" style="margin: auto;">
                            <sa-otp (onChange)="onOTPChange($event)" [showSpinner]="checkingOTP" [errorMsg]="errorMsg" [status]="status"></sa-otp>
                        </div>
                    </div>
    
                    <!-- <sa-button [text]="'Cancel Setup'" [type]="'transparent'" [size]="'medium'" (onClickEvent)="cancleSetup()"></sa-button> -->
                </div>
            </sa-page-layout>
        </div>
    </div>
}
